import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const HomeIcon = ({ label = 'Home', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg viewBox="0 0 300 300" style="enable-background:new 0 0 300 300" xml:space="preserve"><path d="M242.5 114.6 150 39.1l-92.5 75.5V261h66.2v-74.1c0-5.1-2.1-9.2 3-9.2h51.1c5 0 .6 4.2.7 9.3v74h63.9l.1-146.4z" style="fill:#85cee3"/><path d="M282.5 150.7c-1.4 0-2.9-.5-4.1-1.5L150 44.4 21.6 149.2c-2.8 2.3-6.9 1.9-9.1-.9-2.3-2.8-1.9-6.9.9-9.1L145.9 31c2.4-2 5.8-2 8.2 0l132.5 108.2c2.8 2.3 3.2 6.4.9 9.1-1.3 1.6-3.1 2.4-5 2.4z" style="fill:#1d1d1b"/><path d="M244.1 267.6h-68.3c-3.6 0-6.5-2.9-6.5-6.5v-72.2h-39.1v72.2c0 3.6-2.9 6.5-6.5 6.5H55.4c-3.6 0-6.5-2.9-6.5-6.5V113.4c0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5v141.2h55.3v-72.2c0-3.6 2.9-6.5 6.5-6.5h52.1c3.6 0 6.5 2.9 6.5 6.5v72.2h55.3V65c0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5v196.1c0 3.6-2.9 6.5-6.5 6.5z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

HomeIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { HomeIcon }
